import instance from '../xhrService';

const subscriptionApi = {
  create(subscription: any): Promise<any> {
    return instance
      .post(`/api/subscriptions/create`, subscription)
      .then((res) => res.data);
  },

  update(subscription: any, id: number): Promise<any> {
    return instance
      .put(`/api/subscriptions/update/${id}`, subscription)
      .then((res) => res.data);
  },

  delete(id: number): Promise<any> {
    return instance
      .delete(`/api/subscriptions/delete/${id}`)
      .then((res) => res.data);
  },

  show() {
    return instance.get(`/api/subscriptions/show`).then((res) => res.data);
  },

  showPublic() {
    return instance
      .get(`/api/subscriptions/showPublic`)
      .then((res) => res.data);
  },

  showAllPublicSubscriptions() {
    return instance
      .get(`api/showAllPublicSubscriptions`)
      .then((res) => res.data);
  },

  leadGen(data:any) {
    return instance
      .post(`api/leadGen`, {data})
      .then((res) => res.data);
  },

  leadGenUpdate(data:any) {
    return instance
      .put(`api/leadGen`, {data})
      .then((res) => res.data);
  },

  domainAvailabilityCheck(data: any){
    return instance
      .post(`api/domainAvailabilityCheck`, {data})
      .then((res) => res.data);
  },

  showForTenant() {
    return instance
      .get(`/api/subscriptions/showForTenant`)
      .then((res) => res.data);
  },

  choosePlan(subscription_id: number) {
    return instance
      .post(`/api/subscriptions/choosePlan`, { subscription_id })
      .then((res) => res.data);
  },

  changePlan(tenantSubscriptionId: number, newSubscriptionId: number) {
    return instance
      .post(`/api/subscriptions/changePlan`, {
        tenantSubscriptionId,
        newSubscriptionId,
      })
      .then((res) => res.data);
  },

  chooseAddOn(
    tenantSubscriptionId: number,
    addonId: number,
    is_enabled: boolean,
  ) {
    return instance
      .post(`/api/subscriptions/chooseAddOn`, {
        tenantSubscriptionId,
        addonId,
        is_enabled,
      })
      .then((res) => res.data);
  },

  getTenantListBySubscription(subscriptionId: number) {
    return instance
      .get(`/api/subscriptions/getTenantListBySubscription/${subscriptionId}`)
      .then((res) => res.data);
  },

  changeOrder(orderedData: any) {
    return instance
      .post(`/api/subscriptions/changeOrder`, { orderedData })
      .then((res) => res.data);
  },
};

export default subscriptionApi;
